import { CSSObject } from "@emotion/react";
import {
  ButtonStyleOverrides,
  constants,
  TooltipDialogStyleOverrides,
  typographyStyles,
} from "@newsela/angelou";

const neutral600 = constants.colors.ui.neutral[600];

const { heading3Obj } = typographyStyles;

export const rootCss: CSSObject = {
  alignItems: "center",
  display: "flex",
};

export const headingCss: CSSObject = {
  ...heading3Obj,
  fontFamily: typographyStyles.fontFamily.circular.fontFamily,
  paddingLeft: "8px",
  color: neutral600,
};

export const iconCss = {
  circle: {
    stroke: neutral600,
  },
  path: {
    stroke: neutral600,
  },
};

export const tooltipDialogIconCss: TooltipDialogStyleOverrides<CSSObject> = {
  root: {
    width: "16px",
    marginLeft: 6,
    paddingTop: 4,
  },
};

export const tooltipDialogCss: TooltipDialogStyleOverrides<CSSObject> = {
  dialog: {
    root: {
      zIndex: 99,
      maxWidth: "300px",
      border: "none",
    },
  },
};

export const tooltipDialogFooterButtonCss: ButtonStyleOverrides<CSSObject> = {
  root: {
    color: constants.colors.ui.core[700],
    textDecoration: "underline",
    fontSize: "12px !important",
  },
};

export const modalCloseButtonCss: CSSObject = {
  position: "absolute",
  right: 28,
  top: 29,
  color: constants.colors.ui.white[700],
};

export const modalCss: CSSObject = {
  root: {
    zIndex: 100,
  },
};
